import { createContext, useContext, useEffect, useState } from "react";

import { api } from "@/lib/api";

const defaultBrand = {
  colors: {
    primary: "#154A74",
    accent: "#2E86C1",
    background: "#F7F9FC",
    surface: "#FFFFFF",
  },
  logo_url: "/puerto-santa-cruz-logo.png",
  login_image_url: "/puerto-santa-cruz-login.jpg",
};
const BrandContext = createContext(null);

function urlFor(path) {
  if (path.startsWith("http") || !path.startsWith("/api/")) {
    return path;
  }
  return `${process.env.REACT_APP_BACKEND_URL}${path}`;
}

function applyColors(colors) {
  const root = document.documentElement.style;
  root.setProperty("--ink", colors.primary);
  root.setProperty("--ink-hover", colors.accent);
  root.setProperty("--paper", colors.background);
  root.setProperty("--surface", colors.surface);
}

export function BrandProvider({ children }) {
  const [brand, setBrand] = useState(defaultBrand);

  const updateBrand = (nextBrand) => {
    const normalized = {
      ...nextBrand,
      logo_url: urlFor(nextBrand.logo_url),
      login_image_url: urlFor(nextBrand.login_image_url),
    };
    applyColors(normalized.colors);
    setBrand(normalized);
  };

  const refreshBrand = async () => {
    const response = await api.get("/brand");
    updateBrand(response.data);
    return response.data;
  };

  useEffect(() => {
    applyColors(defaultBrand.colors);
    refreshBrand().catch(() => updateBrand(defaultBrand));
  }, []);

  return (
    <BrandContext.Provider value={{ brand, refreshBrand, updateBrand }}>
      {children}
    </BrandContext.Provider>
  );
}

export function useBrand() {
  return useContext(BrandContext);
}
